<template>
  <v-container v-if="RBAC_system_VIEW_SYSTEM">
    <v-row justify="center">
      <v-col md="8" cols="12">
        <v-row v-if="systemInfo" align="end" justify="space-between">
          <v-col md="5" cols="12">
            <v-simple-table>
              <tbody>
                <tr>
                  <td>
                    {{ $t("system_version") }}
                  </td>
                  <td colspan="2">
                    <v-btn v-on:click="showChangelog" color="primary">{{ systemInfo.custId }} - {{ systemInfo.version
                    }}</v-btn>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-if="RBAC_system_CAN_DEPLOY" icon v-on:click="openSettings" text v-bind="attrs" v-on="on"
                          min-width="0">
                          <v-icon large color="primary">mdi-cog-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("settings") }}</span>
                    </v-tooltip>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("hostname") }}</td>
                  <td colspan="2">{{ systemInfo.hostname }}</td>
                </tr>
                <tr>
                  <td>
                    {{ $t("used_space") }}
                  </td>
                  <td colspan="2">
                    {{ systemInfo.usedDbSizeMb }} /
                    {{ systemInfo.maxDbSizeMb }} Mb
                    <v-progress-linear :color="
                      getSpaceColor(
                        (systemInfo.usedDbSizeMb * 100) /
                        systemInfo.maxDbSizeMb
                      )
                    " :value="
  (systemInfo.usedDbSizeMb * 100) / systemInfo.maxDbSizeMb
"></v-progress-linear>
                  </td>
                </tr>

                <tr v-if="RBAC_system_DELETE_LOGS">
                  <td>
                    {{ $t("delete_logs") }}
                  </td>
                  <td :colspan="adminPortal ? 1 : 2">
                    <v-btn @click="clearLogs()" color="warning">
                      <v-icon>mdi-delete</v-icon>
                      {{ systemInfo.logArchiveSizeMb }} Mb<br />Portal
                    </v-btn>
                  </td>
                  <td v-if="adminPortal">
                    <v-btn @click="clearLogs(true)" color="error">
                      <v-icon>mdi-delete</v-icon>
                      {{ systemInfo.logArchiveTotalSizeMb }} Mb<br />Global
                    </v-btn>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("admin_user") }}</td>
                  <td colspan="2">{{ systemInfo.adminUser }}</td>
                </tr>
                <tr>
                  <td>{{ $t("system_env") }}</td>
                  <td colspan="2">
                    <v-icon :color="systemInfo.ifTest ? 'warning' : 'success'">{{
                      systemInfo.ifTest ? "mdi-test-tube" : "mdi-vuetify"
                    }}</v-icon>
                    {{ systemInfo.ifTest ? $t("test") : $t("production") }}
                  </td>
                </tr>
                <tr v-if="
                  adminPortal && (RBAC_system_BACKUP || RBAC_system_RESTORE)
                ">
                  <td>{{ $t("backup_restore") }}</td>
                  <td>
                    <span v-if="RBAC_system_BACKUP">
                      <v-btn icon @click="doBackup">
                        <v-icon color="primary">mdi-cloud-download</v-icon>
                      </v-btn>
                      {{ $t("backup") }}
                    </span>
                  </td>
                  <td>
                    <span v-if="RBAC_system_RESTORE">
                      <v-btn :disabled="esito_restore === 'primary'" icon @click="$refs.inputUpload.click()">
                        <input v-show="false" accept=".asd" ref="inputUpload" type="file" @change="doRestore" />

                        <v-icon color="success">mdi-cloud-upload</v-icon>
                      </v-btn>
                      {{ $t("restore") }}
                    </span>
                  </td>
                </tr>
                <tr v-if="esito_restore">
                  <td colspan="3">
                    <h4 :class="esito_restore + '--text'">
                      {{ progress_restore }} %
                    </h4>
                    <v-progress-linear :color="esito_restore" :value="progress_restore"></v-progress-linear>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>

          <v-col md="5" cols="12">
            <v-simple-table>
              <tbody>
                <tr>
                  <td>{{ $t("ragSoc") }}</td>
                  <td>{{ systemInfo.ragSoc }}</td>
                </tr>
                <tr>
                  <td>{{ $t("ref_person") }}</td>
                  <td>{{ systemInfo.refNome }}</td>
                </tr>
                <tr>
                  <td>{{ $t("telephone") }}</td>
                  <td>{{ systemInfo.refTel }}</td>
                </tr>
                <tr>
                  <td>{{ $t("email") }}</td>
                  <td>{{ systemInfo.refEmail }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <v-col v-if="showLicenses" cols="12">
            <DataTables :showFooter="false" :showSearch="false" v-if="systemInfo && systemInfo.modules" :headers="headers"
              :table-data="systemInfo.modules" hide-default-footer class="elevation-1"></DataTables>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <manage-portal @isUpdated="loadData" ref="managePortalDialog"></manage-portal>
    <v-dialog v-model="showChangelogDialog">
      <v-card style="margin: 0px">
        <v-card-title class="text-right">
          <v-btn style="position: absolute; right: 0px; top: 10px;" color="green darken-1" text
            @click="showChangelogDialog = false">{{ $t("close") }}</v-btn>
        </v-card-title>
        <v-card-text v-html="changeLogData"> </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import VueMarkdown from "vue-markdown";
import DataTables from "@/components/base/DataTables.vue";
import managePortal from "@/app/admin/managePortal.vue";
import Swal from "sweetalert2";

export default {
  name: "system-info",
  components: {
    DataTables,
    "vue-markdown": VueMarkdown,
    "manage-portal": managePortal,
  },
  props: {
    showLicenses: false,
    custId: null,
  },
  data() {
    return {
      showChangelogDialog: false,
      changeLogData: null,
      progress_restore: null,
      esito_restore: null,
      RBAC_system_VIEW_SYSTEM: false,
      RBAC_system_DELETE_LOGS: false,
      RBAC_system_CAN_DEPLOY: false,
      RBAC_system_BACKUP: false,
      RBAC_system_RESTORE: false,
      systemInfo: null,
      restoreFile: null,
      headers: [
        { text: this.$t("module"), value: "module", type: "text" },
        { text: this.$t("description"), value: "description", type: "text" },
        { text: this.$t("expire_date"), value: "expireDate", type: "date" },
        { text: this.$t("status"), value: "status", type: "icons" },
      ],
    };
  },
  methods: {
    getSpaceColor(perc) {
      if (perc < 80) return "primary";
      if (perc < 90) return "warning";
      return "error";
    },
    openSettings() {
      this.$refs.managePortalDialog.open(this.custId);
    },
    getIconCode(icon, color) {
      return (
        '<i aria-hidden="true" class="v-icon notranslate mdi mdi-' +
        icon +
        " theme--light " +
        color +
        '--text"></i>'
      );
    },
    showChangelog() {
      let _ = this;
      _.changeLogData = "";
      _.chiamataAxios("GET", "/public/portal/changelog").then((response) => {
        for (let [key, value] of Object.entries(response.data)) {
          _.changeLogData +=
            "<h4>Version " +
            key +
            "</h4>" +
            value
              .replace(new RegExp("\n", "g"), "<br/>")
              .replace(
                new RegExp("- feat:", "g"),
                _.getIconCode("plus", "success")
              )
              .replace(
                new RegExp("- fix:", "g"),
                _.getIconCode("bug", "error")
              );
        }

        _.showChangelogDialog = true;
      });
    },
    doBackup() {
      window.open(this.authorizeLink("/auth/portal/getBackupDb"));
    },
    doRestore(event) {
      let _ = this;
      const file = event.target.files[0];
      var bodyFormData = new FormData();
      bodyFormData.append("restore", file);
      _.esito_restore = "primary";
      _.axios({
        method: "POST",
        data: bodyFormData,
        onUploadProgress: function (progressEvent) {
          _.progress_restore = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        },
        url: "/auth/portal/restoreDb",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("authToken"),
          "Cache-Control": "no-cache",
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
        },
      })
        .then(function (response) {
          //handle success
          _.$refs.inputUpload.value = "";
          if (response.data.msg.severity === 0) {
            _.progress_restore = 100;
            _.esito_restore = "success";
            _.loadData();
          } else {
            _.esito_restore = "error";
          }
        })
        .catch(function (response) {
          //handle error
          console.log(response);
          _.esito_restore = "error";
          _.$refs.inputUpload.value = "";
        });
    },
    clearLogs(ifAll) {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          _.chiamataAxios(
            "DELETE",
            ifAll ? "/auth/portal/clearLogs/all" : "/auth/portal/clearLogs"
          ).then((response) => {
            if (response.msg.esito) {
              let html = "<strong>" + response.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });
              _.loadData();
            }
          });
        }
      });
    },
    loadData() {
      let _ = this;
      _.chiamataAxios("GET", "/auth/portal/getSystemStatus").then(
        (response) => {
          _.systemInfo = response.data;
          _.systemInfo.modules = _.systemInfo.modules.map((modulo) => {
            let minutes = 1000 * 60;
            let hours = minutes * 60;
            let days = hours * 24;

            let diff_date = Math.round(
              (new Date(modulo.expireDate) - new Date()) / days
            );
            let status = [
              {
                icon: "mdi-check-bold",
                color: "green",
                text: diff_date + " " + _.$t("days_remaining"),
              },
            ];
            if (diff_date < 30)
              status = [
                {
                  icon: "mdi-alert",
                  color: "warning",
                  text: diff_date + " " + _.$t("days_remaining"),
                },
              ];
            if (diff_date < 0)
              status = [
                {
                  icon: "mdi-close-thick",
                  color: "error",
                  text: _.$t("expired"),
                },
              ];
            modulo.status = status;
            return modulo;
          });
        }
      );
    },
  },
  mounted() {
    this.loadData();
    this.RBAC_system_VIEW_SYSTEM = this.checkUserRole("system", "VIEW_SYSTEM");
    this.RBAC_system_BACKUP = false;
    this.RBAC_system_RESTORE = false;
    // this.RBAC_system_BACKUP = this.checkUserRole("system", "BACKUP");
    // this.RBAC_system_RESTORE = this.checkUserRole("system", "RESTORE");
    this.RBAC_system_DELETE_LOGS = this.checkUserRole("system", "DELETE_LOGS");
    this.RBAC_system_CAN_DEPLOY = this.checkUserRole("system", "CAN_DEPLOY");
  },
  computed: {
    adminPortal() {
      if (window.systemData) return window.systemData.adminPortal;
      else return false;
    },
  },
};
</script>